import { audioUploads, GET_AUDIO_UPLOADS } from './audioUploads';
import { environment, GET_ENVIRONMENT } from './environment';
import { session } from './session';
import { uiState } from './uiState';

export const queryStrings = {
    GET_AUDIO_UPLOADS,
    GET_ENVIRONMENT,
};

export const fieldPolicies = {
    audioUploads,
    environment,
    session,
    uiState,
};
